import { Table } from '@chakra-ui/react'
import FileRow from './FileRow'
import useStore from '../../../../store'
import { useState, useEffect } from 'react'
import FileDetails from './FileDetails'
import Spinner from '../../../common/Spinner'
import FilesTableHeader from './FilesTableHeader'
import { colors } from '../../../../utilities/colors'

export default function FilesTable({dealerId, dealerFiles, fileType}) {
  const [selectedFile, setSelectedFile] = useState(null)
  const fetchDealerDocuments = useStore((state) => state.fetchDealerDocuments)
  const fetchDealerFile = useStore((state) => state.fetchDealerFile)
  const dealerFilesFetching = useStore((state) => state.dealerFilesFetching)
  const fetchFolderList = useStore((state) => state.fetchFolderList)
  const fetchLotPhotos = useStore((state) => state.fetchLotPhotos)

  useEffect(() => {
    setSelectedFile(null)
    fetchFolderList(dealerId)
  }, [dealerFiles])

  return(
    <div className="h-full bg-grey-900">
      <div className="relative flex flex-col">
        {selectedFile ?
          <FileDetails
            onBack={() => {
              setSelectedFile(null)
              fetchDealerDocuments(dealerId)
              fetchLotPhotos(dealerId)
            }}
            fileId={selectedFile.id}
            dealerId={dealerId}
            setSelectedFile={setSelectedFile}
          />
        :
          <div>
            {!dealerFilesFetching ?
              <Table.Root variant='simple' bg={colors.grey900} style={{ tableLayout: 'fixed', width: '100%' }}>
                <Table.Header>
                  <Table.Row>
                    <Table.ColumnHeader color={colors.grey300}>
                      <div className='flex items-center space-x-2'>
                        <FilesTableHeader dealerId={dealerId} modalTitle={'Add a File'} fileType={fileType}/>
                        <span>File</span>
                      </div>
                    </Table.ColumnHeader>
                    <Table.ColumnHeader color={colors.grey300}>Folder</Table.ColumnHeader>
                    <Table.ColumnHeader color={colors.grey300}>Date Added</Table.ColumnHeader>
                    <Table.ColumnHeader color={colors.grey300}>Added By</Table.ColumnHeader>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {dealerFiles.map((file) => (
                    <FileRow key={file.id} file={file} dealerId={dealerId} onClick={() => {
                      setSelectedFile(file)
                      fetchDealerFile(file.id, dealerId)
                    }}/>
                  ))}
                </Table.Body>
              </Table.Root>
            :
              <Spinner/>
            }
          </div>
        }
      </div>
    </div>
  )
}